class ScProductDescription extends HTMLElement {
    constructor() {
        super();

        const button = this.querySelector(".main-product__description-show-more-button");
        const container = this.querySelector(".main-product__description");

        if (!button || !container) return;

        // Wait for DOM to fully render text
        requestAnimationFrame(() => {
            if (!this.isTruncated(container)) {
                button.style.display = "none";
            }else{
                button.style.display = "inline-block";
            }
        });

        button.addEventListener("click", () =>
            this.toggleProductDescriptionContent(container, button)
        );
    }

    toggleProductDescriptionContent(container, button) {
        container.classList.toggle("show-more");
        button.innerText = container.classList.contains("show-more")
            ? "Show less"
            : "Show more";
    }

    isTruncated(container) {
        const lineHeight = parseFloat(getComputedStyle(container).lineHeight);
        const maxLines = 2;
        const maxHeight = lineHeight * maxLines;
        return container.scrollHeight > maxHeight + 1; // +1 buffer for rounding
    }
}

window.customElements.define("sc-product-description", ScProductDescription);
